export const removeSpace = (name: string): string => {
  return name?.trim()?.replace(/\s+/g, '-')?.toLowerCase() || '';
};

export const normalizeString = (str: string) => {
  return str?.replace(/-/g, ' ').replace(/&/g, ' & ').toLowerCase();
};

export const formatParams = (param: string): string => {
  if (!param) return '';

  // Split by hyphens and capitalize each word
  return param
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
